import React, { Fragment } from "react";
import Header from "../../shared/marketing-header";
import Footer from "../../shared/marketing-footer";
import "../../../styles/reset.desktop.css";
import "../../../styles/global.css";
import "../../../styles/slick.css";
import "../../../styles/slick-theme.css";
import "../../../styles/slick-reset-desktop.css";
import "@cars24/turbo-web/lib/index.css";
import ErrorHandler from "../../shared/with-error-handler";

export default function withMarketingLayout(WrappedComponent, header = true, footer = true) {

    const MarketingLayout = (props) => {
        return (
            <Fragment>
                {header && <Header {...props} />}
                <ErrorHandler>
                    <WrappedComponent {...props} />
                </ErrorHandler>
                {footer && <Footer {...props} />}
            </Fragment>
        );
    };
    return MarketingLayout;
}
